import React from "react";
import { Box } from "@mui/material";
import {
  Bush1,
  Church,
  Cloud1,
  Cloud2,
  Flowers,
  Grass,
  Grass2,
  Hill1,
  Hill2,
  Trees,
} from "./bg-images/cover-art";

const LandscapeScene = () => {
  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 3,
          opacity: 1,
          background:
            "radial-gradient(circle at 50% 80%, rgb(215, 228, 234),rgb(0, 0, 0, 0))",
          // rgb(244, 219, 176)
        }}
      />

      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 20,
          pointerEvents: "none",
          background: `
              radial-gradient(
                ellipse at center 50%,
                transparent 40%,
                rgba(255,255,255,0.2) 70%,
                rgba(255,255,255,1) 90%
              ),
              linear-gradient(
                to right,
                rgba(255,255,255,1) 0%,
                rgba(255,255,255,0) 5%,
                rgba(255,255,255,0) 95%,
                rgba(255,255,255,1) 100%
              ),
              linear-gradient(
                to bottom,
                rgba(255,255,255,1) 0%,
                rgba(255,255,255,0) 5%,
                rgba(255,255,255,0) 95%,
                rgba(255,255,255,1) 100%
              )
            `,
        }}
      />
      <Cloud1
        start={"0%"}
        end={"-500%"}
        speed={"35"}
        sx={{
          position: "absolute",
          width: "25%",
          left: "100%",
          top: "25%",
          zIndex: 2,
        }}
      />

      <Cloud2
        start={"0%"}
        end={"500%"}
        speed={"45"}
        sx={{
          position: "absolute",
          width: "40%",
          left: "-100%",
          top: "4%",
          zIndex: 2,
        }}
      />

      <Box sx={{ position: "relative" }}>
        <Hill2
          sx={{
            position: "absolute",
            width: "40%",
            right: 0,
            bottom: "40%",
            zIndex: 5,
          }}
        />
        <Hill2
          sx={{
            position: "absolute",
            width: "50%",
            left: 0,
            bottom: "20%",
            zIndex: 5,
            transform: "scaleX(-1)",
          }}
        />
        <Hill1
          sx={{
            position: "relative",
            width: "100%",
            zIndex: 5,
          }}
        />
        <Church
          sx={{
            position: "absolute",
            width: "45%",
            zIndex: 6,
            left: "51%",
            bottom: "50%",
            transform: "translateX(-50%)",
          }}
        />

        <Grass2
          sx={{
            position: "absolute",
            width: "4%",
            bottom: "51%",
            left: "68%",
            opacity: 0.8,
            zIndex: 9,
          }}
        />
        <Flowers
          sx={{
            position: "absolute",
            width: "10%",
            bottom: "56%",
            left: "40%",
            zIndex: 7,
          }}
        />
        <Flowers
          sx={{
            position: "absolute",
            width: "10%",
            bottom: "56%",
            left: "50%",
            zIndex: 7,
          }}
        />
        <Bush1
          sx={{
            position: "absolute",
            width: "30%",
            bottom: "44%",
            left: "35%",
            zIndex: 8,
            opacity: 0.9,
            // filter: "brightness(1.2)",
          }}
        />
        <Grass
          sx={{ position: "absolute", width: "100%", bottom: 0, zIndex: 6 }}
        />
        <Trees
          sx={{ position: "absolute", width: "35%", bottom: 0, zIndex: 6 }}
        />
        <Trees
          sx={{
            position: "absolute",
            width: "6%",
            bottom: "60%",
            left: 0,
            zIndex: 4,
          }}
        />
        <Trees
          sx={{
            position: "absolute",
            width: "6%",
            bottom: "64%",
            left: "5%",
            zIndex: 4,
          }}
        />
        <Trees
          flipped={true}
          sx={{
            position: "absolute",
            width: "6%",
            bottom: "63%",
            left: "10%",
            zIndex: 4,
          }}
        />
        <Trees
          sx={{
            position: "absolute",
            width: "6%",
            bottom: "60%",
            left: "15%",
            zIndex: 4,
          }}
        />
        <Trees
          flipped={true}
          sx={{
            position: "absolute",
            width: "12%",
            bottom: "76%",
            right: "24%",
            zIndex: 4,
          }}
        />
        <Trees
          flipped={true}
          sx={{
            position: "absolute",
            width: "12%",
            bottom: "64%",
            right: "19%",
            zIndex: 4,
          }}
        />
      </Box>
    </>
  );
};

export default LandscapeScene;
